import { toast } from '@/hooks/use-toast';

/**
 * Message utility class for showing toast notifications
 * Uses shadcn/ui toast system with Linear/Notion/Vercel Dashboard style
 */
export default class Message {
  static success(message: string | null) {
    toast({
      title: message ?? '',
      variant: 'default',
    });
  }

  static error(message: string | null) {
    toast({
      title: message ?? '',
      variant: 'destructive',
    });
  }

  static info(message: string | null) {
    toast({
      title: message ?? '',
      variant: 'default',
    });
  }

  static warning(message: string | null) {
    toast({
      title: message ?? '',
      variant: 'default',
    });
  }
}
